import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './studymnav.css'
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';


function StudyMNav(props) {
  const { t } = useTranslation();

  return (

    <div className='studym'>

      <div className='live'>
        <div className='live-menu'>
          <div className='live-item'>
            {
              props.auth.user_type != "99"&&
              <div className={props.selectedtab == "StudyLibrary" ? "live-links-active" : "live-links"} onClick={() =>{ props.selecttab("StudyLibrary"); props.changedmsg()}}>
              <span >{t('studyMaterial.studyLibrary')}</span>
            </div>
            }
           
          </div>
          {
            props.auth.enable_eLearn_feature &&
            <div className='live-item'>
              <div className={props.selectedtab == "PurchasedProduct" ? "live-links-active" : "live-links"} onClick={() =>{ props.selecttab("PurchasedProduct"); props.changedmsg()}} >
                <span>{t('studyMaterial.purchasedProduct')}</span>
              </div>
            </div>
          }
        </div>

      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({ auth: state.auth })
export default connect(mapStateToProps)(StudyMNav);